import { Button, Modal } from 'flowbite-react';
import React, { useState } from 'react';
import { Loader } from 'ui';
import MentorAvailabilityDetails from './availability/MentorAvailabilityDetails';
import { useMutation } from 'react-query';
import { updateSlots } from 'src/apis/userAvailability';
import { useToast } from 'src/context/ToastProvider';
import { useGetAllSlotsQuery } from 'src/hooks/userAvailability.hooks';
import { useUserContext } from 'src/context/UserProvider';
import { UserAvailabilityInput } from 'types';
import { get } from 'lodash';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	mentorId: string;
}

const UpdateAvailabilityModal = ({ isOpen, onClose, mentorId }: Props) => {
	const toast = useToast();
	const { user } = useUserContext();

	const [availabilities, setAvailabilities] = useState<UserAvailabilityInput[]>([]);

	const { isLoading, refetch } = useGetAllSlotsQuery(isOpen ? user?._id : '', data =>
		setAvailabilities(data.availabilities ?? []),
	);

	const updateAvailabilityFn = useMutation([], updateSlots, {
		onSuccess() {
			refetch();
			toast({
				title: 'Slots updated successfully.',
				type: 'success',
				duration: 3000,
			});
			onClose();
		},
		onError(error: any) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				type: 'error',
				title: errorMessage,
			});
		},
	});
	if (isLoading) return <Loader />;
	return (
		<>
			<Modal dismissible={true} show={isOpen} onClose={onClose} size="7xl">
				<Modal.Header>Update your availability</Modal.Header>
				<Modal.Body className="h-[75vh] overflow-y-scroll">
					{isLoading ? (
						<Loader />
					) : (
						<MentorAvailabilityDetails
							availabilities={availabilities}
							setAvailabilities={setAvailabilities}
							allowUpdate={true}
						/>
					)}
				</Modal.Body>
				<Modal.Footer className="justify-end p-[8px]">
					<Button
						color="purplePlaced"
						className="w-[100%]"
						disabled={updateAvailabilityFn.isLoading}
						onClick={() => {
							updateAvailabilityFn.mutate({ id: mentorId ?? '', slots: availabilities });
						}}
					>
						{updateAvailabilityFn.isLoading ? <Loader /> : 'Update'}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default UpdateAvailabilityModal;
